import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ae853b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hedge Funds", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Know your risks."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("All of them.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "half" }, "A full end to end risk platform, front to back.")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "half" }, "The Derivitec Risk Portal allow you to upload your portfolio directly, regardless of asset class, regardless of complexity. You can then run any risk that makes sense to your organisation with all supporting market data provided on an end of day basis as standard. Integrate your live data and workflow feeds through our powerful C sharp API technology and you have a full end to end risk platform, front to back. Use our Python APIs to generate reports and analysis, pre and post trade, the scope is limitless.")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "third" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "right" }, "Features & Benefits")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Consistency"),
    /*#__PURE__*/_createElementVNode("p", null, "We operate a single version of the truth. Your entire organisation, be it back office, middle office or front office, use the same data and the same models, ensuring that everyone is on the same page, all the time.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns flexibility" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Flexibility"),
    /*#__PURE__*/_createElementVNode("p", null, "There is no one right answer when it comes to risk. You need to have confidence that you’ve looked at all the angles, because the results are frequently surprising. In addition to the comprehensive standard risk reports, we tailor make reports to fit your organisations specifications exactly, and even allow you to produce analysis on the fly through our powerful Python API.")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right power" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Power"),
    /*#__PURE__*/_createElementVNode("p", null, "Regardless of whether you’re trading 20 stocks, or 10,000 derivatives, our award winning cloud based technology scales on demand to meet your calculation requirements. Gone are the days of the overnight, non-completing risk run. Plug this into your other workflow components through our C-sharp API and you have a front to back system of unlimited power.")
  ])
], -1))
const _hoisted_8 = { class: "third" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "name" }, "Multi-strategy Hedge Fund", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subline" }, "Hong Kong", -1))
const _hoisted_11 = { class: "two-thirds" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Derivitec’s robust IT infrastructure and user-friendly Risk Portal are unparalleled."),
  /*#__PURE__*/_createElementVNode("p", null, "Derivitec’s robust IT infrastructure and user-friendly Risk Portal are unparalleled inasmuch as they afford us a complete suite of analytical and reporting tools that allow for in-depth analysis and fine toothcomb scrutiny of portfolio structures at fund and entity levels."),
  /*#__PURE__*/_createElementVNode("footer", null, [
    /*#__PURE__*/_createElementVNode("cite", null, "Multi-strategy Hedge Fund"),
    /*#__PURE__*/_createElementVNode("p", null, "Hong Kong")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_client_box = _resolveComponent("client-box")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head bg-right-sm",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "features" }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_client_box, {
            class: "company-logo",
            standalone: true
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_router_link, {
            class: "button",
            to: "/clients"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Read More")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}